import { Scale } from 'lucide-react';

export function BoundaryNotice() {
  return (
    <aside className="border-t border-slate-200 bg-slate-100 px-4 py-4 text-center text-xs leading-5 text-slate-600">
      <p className="inline-flex items-start justify-center gap-2">
        <Scale aria-hidden="true" className="mt-0.5 size-4 shrink-0 text-slate-500" />
        <span>检查结果仅用于辅助复核，不构成造价审核结论。</span>
      </p>
    </aside>
  );
}
